import React, { useState, useContext, useEffect } from "react";
import Footer from "../Footer";
import SignIn from "../SignIn";
import SignUp from "../SignUp";
import ConfirmEmail from "../ConfirmEmail";
import { AuthContext } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Login() {
    
    const [showSignIn, setSignIn] = useState(true);;
    
    const toggleForm = () => {
        setSignIn (!showSignIn);
    }

    const { currentUser, user } = useContext(AuthContext);

    const navigate = useNavigate();

    useEffect(() => {
        if (!!user && user.emailVerified)
            navigate('/');
    }, [currentUser, user]);

    return (
        
        <div className="page-auth">

            { currentUser && !user.emailVerified
                ?
                <>
                    <ConfirmEmail user={user}/>
                </>
                :
                showSignIn ?

                    <>
                        <SignIn toggleForm={toggleForm} />
                    </>

                    :

                    <>
                        <SignUp toggleForm={toggleForm} />
                    </>


            }


            <Footer />
        
        </div>
        
        
    )
        
}

